import { Button, ButtonProps } from "@mui/material";

export default function VidletButton({ sx, ...props }: ButtonProps) {
  return (
    <Button
      variant="contained"
      sx={{
        borderRadius: "1rem",
        whiteSpace: "nowrap",
        minWidth: "max-content",
        ...sx,
      }}
      {...props}
    />
  );
}
